import Moment from "react-moment";
import dateTimeHelper from "../../util/dateTimeHelper";
import { Tooltip } from "@mui/material";
import Job from "../../models/job";

const JobsTable: React.FC<{ jobs: Job[]; showRecurrentJobsInfo: boolean }> = ({
  jobs,
  showRecurrentJobsInfo,
}) => {
  const hasStatusMessage = (job: Job) => {
    return job.statusMessage && job.statusMessage.length !== 0;
  };

  return (
    <table className="table table-hover">
      <thead>
        <tr>
          <th scope="col">Job Name</th>
          <th scope="col">Job Type</th>
          <th scope="col">Project Code</th>
          <th scope="col">User</th>
          <th scope="col">Create Date</th>
          <th scope="col">Start Date</th>
          <th scope="col">End Date</th>
          <th scope="col">Job Status</th>
          <th scope="col">Job Message</th>
          <th scope="col">Job Guid</th>
          {showRecurrentJobsInfo && (
            <>
              <th scope="col">Occurance Type</th>
              <th scope="col">Occurance Day</th>
              <th scope="col">Occurance Time</th>
              <th scope="col">Occurance Date</th>
              <th scope="col">Occurance Last Job Status</th>
              <th scope="col">Mail List</th>
            </>
          )}
        </tr>
      </thead>
      <tbody>
        {jobs.map((job: Job) => (
          <tr key={job.idJob.toString()}>
            <td>{job.jobName}</td>
            <td>{job.jobType}</td>
            <td>{job.project?.projectCode}</td>
            <td>{job.user?.email}</td>
            <td>
              <Moment format={dateTimeHelper.dateTimeFormat}>
                {job.createDate}
              </Moment>
            </td>
            <td>
              <Moment format={dateTimeHelper.dateTimeFormat}>
                {job.startDate}
              </Moment>
            </td>
            <td>
              <Moment format={dateTimeHelper.dateTimeFormat}>
                {job.endDate}
              </Moment>
            </td>
            <td>{job.jobStatus}</td>
            {!hasStatusMessage(job) && <td>&nbsp;</td>}
            {hasStatusMessage(job) && (
              <td>
                <Tooltip
                  title={
                    <span style={{ fontSize: "16px" }}>
                      {job.statusMessage}
                    </span>
                  }
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: "500px",
                      },
                    },
                  }}
                >
                  <div className="cut-text" style={{ width: "400px" }}>
                    {job.statusMessage}
                  </div>
                </Tooltip>
              </td>
            )}
            <td>{job.jobGuid}</td>
            {showRecurrentJobsInfo && (
              <>
                <td>{job.occurrenceType}</td>
                <td>{job.occurrenceDay}</td>
                <td>
                  <Moment format={dateTimeHelper.timeFormat}>
                    {job.occurrenceTime}
                  </Moment>
                </td>
                <td>
                  <Moment format={dateTimeHelper.dateFormat}>
                    {job.occurrenceDate}
                  </Moment>
                </td>
                <td>{job.occurrenceLastJobStatus}</td>
                <td>
                  <Tooltip
                    title={
                      <span style={{ fontSize: "16px" }}>
                        {job.jobMailLists.length > 0 &&
                          job.jobMailLists[0].mailList}
                      </span>
                    }
                    componentsProps={{
                      tooltip: {
                        sx: {
                          maxWidth: "500px",
                        },
                      },
                    }}
                  >
                    <div className="cut-text" style={{ width: "200px" }}>
                      {job.jobMailLists.length > 0 &&
                        job.jobMailLists[0].mailList}
                    </div>
                  </Tooltip>
                </td>
              </>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default JobsTable;
